// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "e124b810c99426ea7e87b2751d7ffa576817071c/static/css/" + chunkId + "." + "0b63a1be" + ".chunk.css";
};